export interface ParentIFrameProps {
  document: {
    scrollHeight: number;
    scrollWidth: number;
  };
  iframe: {
    bottom: number;
    height: number;
    left: number;
    right: number;
    top: number;
    width: number;
    x: number;
    y: number;
  };
  viewport: {
    height: number;
    offsetLeft: number;
    offsetTop: number;
    pageLeft: number;
    pageTop: number;
    scale: number;
    width: number;
  };
}

export interface IFrameObject {
  close(): void;
  disconnect(): void;
  moveToAnchor(anchor: string): void;
  resize(): void;
  sendMessage(message: any, targetOrigin?: string): void;
}

export interface IFrameComponent extends HTMLIFrameElement {
  iframeResizer?: IFrameObject;
}

export enum IframeMessageType {
  BETSLIP_CLOSED = 'betslipClosed',
  BETSLIP_OPENED = 'betslipOpened',
  FILTERS_CLOSED = 'filtersClosed',
  FILTERS_OPENED = 'filtersOpened',
  FP_CONSENT_REQUEST = 'FP_CONSENT_REQUEST',
  FP_CONSENT_RESPONSE = 'FP_CONSENT_RESPONSE',
  FP_CONSENT_UPDATED = 'FP_CONSENT_UPDATED',
  GET_PARENT_HEIGHTS = 'getParentHeights',
  GTM_EVENT = 'gtmEvent',
  IFRAME_HEALTH = 'iframeHealth',
  OPEN_AUTH_MODAL = 'openAuthModal',
  SPA_TAB_CHANGE = 'spaTabChange',
}

export type IframeModalType = 'betslip' | 'filters';

export interface IframeChildMessageEvent {
  iframe: HTMLIFrameElement;
  message: {
    data?: any;
    type: IframeMessageType;
  };
}

export interface IframeParentMessageEvent {
  data?: any;
  type: IframeMessageType;
}

export interface IframeHealthMessageData {
  contentHeight?: number;
  path?: string;
}

export interface ConsentRequestMessage {
  type: typeof IframeMessageType.FP_CONSENT_REQUEST;
}

export interface ConsentResponseMessage {
  privacyOK: boolean;
  timestamp: number;
  type: typeof IframeMessageType.FP_CONSENT_RESPONSE;
}

export interface ConsentUpdatedMessage {
  privacyOK: boolean;
  timestamp: number;
  type: typeof IframeMessageType.FP_CONSENT_UPDATED;
}

export type ConsentMessage = ConsentRequestMessage | ConsentResponseMessage | ConsentUpdatedMessage;
